"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRadius = void 0;

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var RADIUS = ui_symbols_1.LINE.RADIUS;
var radii;

(function (radii) {
  radii["sm"] = "SMALL";
  radii["md"] = "MEDIUM";
  radii["lg"] = "LARGE";
  radii["xl"] = "XLARGE";
  radii["round"] = "ROUND";
})(radii || (radii = {}));

var getRadius = function getRadius(radius, theme) {
  var _a, _b, _c;

  if (radii[radius] in RADIUS) {
    var _r = radii[radius];
    return (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.LINE) === null || _a === void 0 ? void 0 : _a.RADIUS) === null || _b === void 0 ? void 0 : _b[_r]) !== null && _c !== void 0 ? _c : RADIUS[_r];
  } else {
    console.warn("\"".concat(radius, "\" is not a valid option for a radius.\n      Valid options are: ").concat(Object.keys(radii).join(', '), "."));
    return "";
  }
};

exports.getRadius = getRadius;